// extracted by mini-css-extract-plugin
module.exports = {"Skew":"SkewArea_Skew__3-zaJ"};